import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  initials: 'CR',
  text: 'El Módulo 3 fue el más importante para mí. Nunca nadie me había explicado tan claramente por qué reaccionaba como reaccionaba ante ciertas personas. Lo leí subrayando cada página.',
  name: 'Cecilia R.',
  city: 'Mendoza'
}, {
  initials: 'SC',
  text: 'Soy de las que empieza y abandona. Pero el ebook es tan práctico que terminé los 6 módulos en una semana. Las frases del Bonus 1 las uso todos los días.',
  name: 'Sofía C.',
  city: 'La Plata'
}, {
  initials: 'PA',
  text: 'El bonus de detectar manipuladores me abrió los ojos. Identifiqué patrones en mi familia que llevaba años sin ver. Ahora respondo de otra manera y todo cambió.',
  name: 'Paula A.',
  city: 'Neuquén'
}, {
  initials: 'JM',
  text: 'El Módulo 5 sobre proteger tu energía mental fue clave. Llevaba meses agotada y no sabía por qué. Empecé a aplicar las técnicas y en dos semanas algo se movió.',
  name: 'Julia M.',
  city: 'Rosario'
}, {
  initials: 'MV',
  text: 'Compré el ebook y los bonus. El de jefes difíciles fue lo mejor. Tengo una jefa muy complicada y antes salía agotada del trabajo. Ahora salgo entera.',
  name: 'María V.',
  city: 'Tucumán'
}, {
  initials: 'GR',
  text: 'Lo que más me impactó fue el Módulo 6 con casos reales. Cada caso era similar al mío. Ver las soluciones aplicadas me dio claridad para mi propia situación.',
  name: 'Gabriela R.',
  city: 'Santa Fe'
}];
export function TestimonialsSection() {
  return <section className="w-full bg-bg-warm py-20 md:py-28 px-4" data-id="element-343">
      <div className="max-w-6xl mx-auto" data-id="element-344">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-345">
          <div className="inline-flex items-center gap-2 bg-rose-bg text-rose px-4 py-1.5 rounded-full mb-6" data-id="element-346">
            <span className="text-xs font-bold tracking-widest" data-id="element-347">
              ❤️ MÁS LECTORES QUE YA LO TIENEN
            </span>
          </div>
          <h2 className="font-serif font-bold text-3xl sm:text-4xl md:text-5xl text-ink leading-[1.1] uppercase tracking-tight" data-id="element-348">
            Personas que ya empezaron a recuperar su{' '}
            <span className="font-serif-italic text-rose font-normal normal-case" data-id="element-349">
              tranquilidad
            </span>
          </h2>
          <div className="flex flex-col items-center gap-2 mt-6" data-id="element-350">
            <div className="flex gap-1" data-id="element-351">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-rose text-rose" data-id="element-352" />)}
            </div>
            <div className="text-sm text-ink-soft" data-id="element-353">
              <strong data-id="element-354">4.8/5</strong> · basado en{' '}
              <strong className="text-rose" data-id="element-355">+2.000</strong> opiniones
            </div>
          </div>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-356">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.06,
          duration: 0.5
        }} className="bg-white border border-line rounded-3xl p-6 shadow-sm" data-id="element-357">
              <div className="flex items-center gap-3 mb-4" data-id="element-358">
                <div className="w-11 h-11 rounded-full bg-rose text-white flex items-center justify-center font-bold font-serif text-sm" data-id="element-359">
                  {t.initials}
                </div>
                <div className="flex gap-0.5" data-id="element-360">
                  {[...Array(5)].map((_, j) => <StarIcon key={j} className="w-4 h-4 fill-rose text-rose" data-id="element-361" />)}
                </div>
              </div>
              <p className="font-serif-italic text-ink leading-relaxed mb-4" data-id="element-362">
                "{t.text}"
              </p>
              <div className="text-sm font-semibold text-ink pt-4 border-t border-line" data-id="element-363">
                {t.name}{' '}
                <span className="text-muted font-normal" data-id="element-364">— {t.city}</span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}